export const inputStyle = {
    padding: "6px 10px",
    borderRadius: "7px",
    border: "1px solid #e2e8f0",
    fontSize: "13px",
    width: "100%",
    boxSizing: "border-box",
    background: "white",
};

export const labelStyle = {
    fontSize: "11px",
    fontWeight: 600,
    color: "#94a3b8",
    marginBottom: "4px",
    display: "block",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
};

export const textareaStyle = { ...inputStyle, minHeight: "76px", resize: "vertical", lineHeight: 1.4 };

export const DROP_OPTION_STYLE = {
    padding: "7px 12px", fontSize: "13px", cursor: "pointer", userSelect: "none",
    whiteSpace: "nowrap", color: "#1e293b",
};

export const SELECTED_OPTION_BG = "#eff6ff";
export const HOVER_OPTION_BG = "#f8fafc";

export const dropdownPanelStyle = {
    background: "white", border: "1px solid #e2e8f0", borderRadius: "7px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
};

export const sectionTitleStyle = {
    fontSize: "11px", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em",
};

export const whiteCardStyle = {
    background: "white",
    padding: "16px",
    borderRadius: "10px",
    border: "1px solid #f1f5f9",
};

export const kbdStyle = {
    fontSize: "11px", color: "#334155",
    background: "#e2e8f0", border: "1px solid #cbd5e1",
    borderRadius: "4px", padding: "2px 6px", fontFamily: "inherit", fontWeight: 700,
};
